import { render } from "./ViewVente.vue?vue&type=template&id=9c388b8a&scoped=true&ts=true"
import script from "./ViewVente.vue?vue&type=script&lang=ts"
export * from "./ViewVente.vue?vue&type=script&lang=ts"

import "./ViewVente.vue?vue&type=style&index=0&id=9c388b8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c388b8a"]])

export default __exports__